import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { TokenProvider } from "./context/TokenContext";
import { PipelineProvider } from "./context/PipelineContext";
import Layout from "./components/Layout";
import Login from "./components/Login";
import { apiFetch } from "./utils/api";
import Traitement from "./pages/Traitement";
import PokEssais from "./pages/PokEssais";
import Gestion from "./pages/Gestion";
import Visionnement from "./pages/Visionnement";
import MiseEnEau from "./pages/MiseEnEau";
import Admin from "./pages/Admin";
import EntrainementIA from "./pages/EntrainementIA";
import RapportTriage from "./pages/RapportTriage";
import RapportTriagePok from "./pages/RapportTriagePok";

// Session (27/07/2026) : v3 n'avait aucune vérification de session propre,
// il ne fonctionnait que grâce au cookie posé par la v2. `authenticated`
// vaut null pendant la vérification initiale (évite un flash de l'écran de
// connexion pour un utilisateur déjà loggé), puis true/false. L'événement
// "v3:auth-expired" (déclenché par apiFetch sur un 401) permet de rebasculer
// sur l'écran de connexion à tout moment, sans faire transiter ce state à
// travers chaque page.
function useAuth() {
  const [authenticated, setAuthenticated] = useState(null);

  useEffect(() => {
    apiFetch("/api/protected/")
      .then(() => setAuthenticated(true))
      .catch(() => setAuthenticated(false));

    const onExpired = () => setAuthenticated(false);
    window.addEventListener("v3:auth-expired", onExpired);
    return () => window.removeEventListener("v3:auth-expired", onExpired);
  }, []);

  return [authenticated, setAuthenticated];
}

export default function App() {
  const [authenticated, setAuthenticated] = useAuth();

  if (authenticated === null) {
    return <div className="min-h-screen bg-gray-100" />;
  }

  if (!authenticated) {
    return <Login onLogin={() => setAuthenticated(true)} />;
  }

  return (
    <TokenProvider>
      <PipelineProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Traitement />} />
              <Route path="/pok" element={<PokEssais />} />
              <Route path="/gestion" element={<Gestion />} />
              <Route path="/visionnement" element={<Visionnement />} />
              <Route path="/mee" element={<MiseEnEau />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/ia" element={<EntrainementIA />} />
              <Route path="/rapport-triage" element={<RapportTriage />} />
              <Route path="/rapport-triage-pok" element={<RapportTriagePok />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </PipelineProvider>
    </TokenProvider>
  );
}
